import { useState } from 'react'

import {
  AddMembersToPermissionGroupDocument,
  AddMembersToPermissionGroupMutationVariables,
} from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'
import app from 'modules/core/store/models/app'

export default function useAddMembersToPermissionGroup() {
  const [mutating, setMutating] = useState(false)
  const [mutation] = useMutation(AddMembersToPermissionGroupDocument, {
    extractorFn: (data) => data.permissionsMutations.addMembersPermissionsPermissionGroup,
  })

  const addMembersToPermissionGroup = useUnsafeCallback(
    async (variables: AddMembersToPermissionGroupMutationVariables) => {
      // We control the state of the mutation manually instead of using the loading state from
      // useMutation because we need to refetch the MobX collection after the mutation is done.
      // Once the group accesses are migrated to Apollo, we can just rely on the refetchQueries
      // mechanism and remove this.
      setMutating(true)
      try {
        const result = await mutation({ variables })
        const handled = handleResult(result, () => {})
        if (handled.success) {
          await users.fetch()
        } else {
          app.setFlash({
            type: 'wrong',
            message: i18n.t('common.crash.retry'),
          })
        }
      } finally {
        setMutating(false)
      }
    },
    [mutation]
  )

  return [addMembersToPermissionGroup, mutating] as const
}
